'use client'

import { useEffect, useRef } from 'react'

import { useShallow } from 'zustand/react/shallow'

import { isForceGraftcodeOnboardingEnabled } from '@common/helpers'

import { selectGraftcodeOnboardingDevAutoOpenActions } from '@apps/graftcode-onboarding/stores/graftcode-onboarding.selector'
import { useGraftcodeOnboardingStore } from '@apps/graftcode-onboarding/stores/graftcode-onboarding.store'

/** Dev-only: when FORCE is on, reset onboarding once per full page load (not on every client navigation). */
export function useGraftcodeOnboardingDevAutoOpen(enabled: boolean) {
  const { openWizard, reset } = useGraftcodeOnboardingStore(useShallow(selectGraftcodeOnboardingDevAutoOpenActions))
  const ranRef = useRef(false)

  useEffect(() => {
    if (!enabled || !isForceGraftcodeOnboardingEnabled() || ranRef.current) {
      return
    }
    ranRef.current = true
    reset()
    openWizard()
  }, [enabled, openWizard, reset])
}
